'use client';

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import { Iconify } from 'src/components/iconify';

/**
 * 허브 제목·숫자 칸 옆의 **ⓘ** — 올리거나 초점을 주면 기준 안내가 글머리 목록으로 뜬다.
 *
 * 🔑 화면에는 숫자와 기간만 두고, 집계 기준·적용 안 되는 필터·정렬은 여기로 보낸다.
 * ⚠️ 줄이 하나도 없으면 아무것도 그리지 않는다 — 빈 아이콘이 서면 눌러 봐도 볼 것이 없다.
 * ⚠️ 키보드로도 열린다(`IconButton` · `aria-label`) — 툴팁만 기대는 안내라 초점이 닿아야 한다.
 * @param items 명사형 한 줄씩 — 빈 문자열은 걸러 낸다
 */
export function HubInfoTip({ items, size = 16 }: { items?: readonly string[]; size?: number }) {
  const lines = (items ?? []).filter(Boolean);
  if (lines.length === 0) return null;
  return (
    <Tooltip
      arrow
      placement="top"
      enterTouchDelay={0}
      title={
        // 글머리는 직접 그린다(「·」) — 목록 기본 기호는 테마가 지워 왼쪽에 빈 여백만 남는다 · 한 줄이면 기호도 없다
        <Box component="ul" sx={{ margin: 0, padding: 0, py: 0.25, listStyle: 'none' }}>
          {lines.map((line) => (
            <Box component="li" key={line} sx={{ display: 'flex', gap: 1, typography: 'uiMeta', lineHeight: 1.6 }}>
              {lines.length > 1 && <Box component="span" aria-hidden sx={{ flexShrink: 0 }}>·</Box>}
              <span>{line}</span>
            </Box>
          ))}
        </Box>
      }
    >
      <IconButton
        size="small"
        aria-label="기준 안내"
        sx={{ p: 0.25, my: -0.25, flexShrink: 0, color: 'text.disabled', '&:hover': { color: 'text.secondary' } }}
      >
        <Iconify icon="solar:info-circle-linear" width={size} />
      </IconButton>
    </Tooltip>
  );
}
